export default __webpack_public_path__ + "static/media/Back.e4107111.svg";